import { safeLazy } from "../utils/safeLazy";
import FallbackWidget from "./FallbackWidget";
import { widgetImports } from "./widgetImports";

const widgetRegistry = {
  // Banner Widgets
  BasicBanner: safeLazy(widgetImports.BasicBanner, FallbackWidget),
  EssentialBanner: safeLazy(widgetImports.EssentialBanner, FallbackWidget),
  ClassicBanner: safeLazy(widgetImports.ClassicBanner, FallbackWidget),
  PrimeBanner: safeLazy(widgetImports.PrimeBanner, FallbackWidget),
  
  // Navigation Widgets
  BasicNav: safeLazy(widgetImports.BasicNav, FallbackWidget),
  EssentialNav: safeLazy(widgetImports.EssentialNav, FallbackWidget),
  ClassicNav: safeLazy(widgetImports.ClassicNav, FallbackWidget),
  PrimeNav: safeLazy(widgetImports.PrimeNav, FallbackWidget),
  
  // Experience Widgets
  BasicExperienceCard: safeLazy(widgetImports.BasicExperienceCard, FallbackWidget),
  ClassicExperienceCard: safeLazy(widgetImports.ClassicExperienceCard, FallbackWidget),
  EssentialExperience: safeLazy(widgetImports.EssentialExperience, FallbackWidget),
  PrimeExperience: safeLazy(widgetImports.PrimeExperience, FallbackWidget),
  
  // Popular Items Widgets
  BasicPopularItems: safeLazy(widgetImports.BasicPopularItems, FallbackWidget),
  ClassicPopularItems: safeLazy(widgetImports.ClassicPopularItems, FallbackWidget),
  EssentialPopularItems: safeLazy(widgetImports.EssentialPopularItems, FallbackWidget),
  PrimePopularItems: safeLazy(widgetImports.PrimePopularItems, FallbackWidget),
  
  // Combo Widgets
  BasicCombo: safeLazy(widgetImports.BasicCombo, FallbackWidget),
  ClassicCombo: safeLazy(widgetImports.ClassicCombo, FallbackWidget),
  EssentialCombo: safeLazy(widgetImports.EssentialCombo, FallbackWidget),
  PrimeCombo: safeLazy(widgetImports.PrimeCombo, FallbackWidget),
  
  // Footer Widgets
  BasicFooter: safeLazy(widgetImports.BasicFooter, FallbackWidget),
  EssentialFooter: safeLazy(widgetImports.EssentialFooter, FallbackWidget),
  ClassicFooter: safeLazy(widgetImports.ClassicFooter, FallbackWidget),
  PrimeFooter: safeLazy(widgetImports.PrimeFooter, FallbackWidget),
  
  // Contact Form Widgets
  BasicContactForm: safeLazy(widgetImports.BasicContactForm, FallbackWidget),
  ClassicContactForm: safeLazy(widgetImports.ClassicContactForm, FallbackWidget),
  PrimeContactForm: safeLazy(widgetImports.PrimeContactForm, FallbackWidget),
  ModernContactForm: safeLazy(widgetImports.ModernContactForm, FallbackWidget),
  
  // Story Widgets
  BasicStory: safeLazy(widgetImports.BasicStory, FallbackWidget),
  ClassicStory: safeLazy(widgetImports.ClassicStory, FallbackWidget),
  PrimeStory: safeLazy(widgetImports.PrimeStory, FallbackWidget),
  ModernStory: safeLazy(widgetImports.ModernStory, FallbackWidget),
  
  // Blog Widgets
  BasicBlog: safeLazy(widgetImports.BasicBlog, FallbackWidget),
  ClassicBlog: safeLazy(widgetImports.ClassicBlog, FallbackWidget),
  PrimeBlog: safeLazy(widgetImports.PrimeBlog, FallbackWidget),
  ModernBlog: safeLazy(widgetImports.ModernBlog, FallbackWidget),
  
  // Event Widgets
  BasicEvents: safeLazy(widgetImports.BasicEvents, FallbackWidget),
  ClassicEvents: safeLazy(widgetImports.ClassicEvents, FallbackWidget),
  PrimeEvents: safeLazy(widgetImports.PrimeEvents, FallbackWidget),
  ModernEvents: safeLazy(widgetImports.ModernEvents, FallbackWidget),
  
  // Gallery Widgets
  BasicGallery: safeLazy(widgetImports.BasicGallery, FallbackWidget),
  ClassicGallery: safeLazy(widgetImports.ClassicGallery, FallbackWidget),
  PrimeGallery: safeLazy(widgetImports.PrimeGallery, FallbackWidget),
  ModernGallery: safeLazy(widgetImports.ModernGallery, FallbackWidget),
  
  // Layout Widgets
  LeftContentRightMediaLayout: safeLazy(widgetImports.LeftContentRightMediaLayout, FallbackWidget),
  RightContentLeftMediaLayout: safeLazy(widgetImports.RightContentLeftMediaLayout, FallbackWidget),
  SplitPromoCard: safeLazy(widgetImports.SplitPromoCard, FallbackWidget),
  FullWidthHero: safeLazy(widgetImports.FullWidthHero, FallbackWidget),
  
  // Social Media Widgets
  BasicSocialFollow: safeLazy(widgetImports.BasicSocialFollow, FallbackWidget),
  
  // Form Widgets
  CustomizableForm: safeLazy(widgetImports.CustomizableForm, FallbackWidget),
} as const;

export type WidgetType = keyof typeof widgetRegistry;
export default widgetRegistry;
